import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#0052B4\" d=\"M0 12c0 6.627 5.373 12 12 12V12z\"></path><path fill=\"#D80027\" d=\"M12 0c6.627 0 12 5.373 12 12H12z\"></path><path fill=\"#0052B4\" d=\"m7.143 4.175.777 2.391h2.515L8.4 8.044l.777 2.392-2.034-1.478-2.034 1.478.777-2.392-2.034-1.478h2.514z\"></path><path fill=\"#D80027\" d=\"m16.858 13.565.777 2.391h2.514l-2.034 1.478.777 2.392-2.034-1.478-2.034 1.478.777-2.392-2.035-1.478h2.515z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }